export default {
	changeMsg(state, msg) {
		state.msg = msg;
	},
	changeConfig(state, config) {
		state.config = config;
	}
};